import React from 'react';
interface CurrencyFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
}
export function CurrencyField({
  label,
  value,
  onChange,
  placeholder = '0.00',
  required = false
}: CurrencyFieldProps) {
  const handleChange = (rawValue: string) => {
    const cleaned = rawValue.replace(/[^0-9.]/g, '');
    onChange(cleaned);
  };
  const formatDisplay = (val: string) => {
    if (!val) return '';
    const num = parseFloat(val);
    if (isNaN(num)) return val;
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  };
  return <div className="flex flex-col gap-1" data-id="element-99">
      <label className="text-sm font-medium text-gray-700" data-id="element-100">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-101">*</span>}
      </label>
      <div className="relative" data-id="element-102">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-103">
          $
        </span>
        <input type="text" value={formatDisplay(value)} onChange={e => handleChange(e.target.value)} placeholder={placeholder} required={required} className="w-full pl-7 pr-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" data-id="element-104" />
      </div>
    </div>;
}